import { textureAssetCompressed } from '../assetStore'
import { useCompressedTexture } from '../ktx2Textures'

export function useShadowTexture() {
    const shadowTexture = useCompressedTexture(textureAssetCompressed.Shadow_Alpha)
    // shadowTexture.colorSpace = THREE.SRGBColorSpace
    return shadowTexture
}
